// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { BadgeStyles } from './consts';
import { getStyle, getIcon, getStatusBadgeText } from './utils';

const BillStatusBadge = ({ status, testId }: { status: string, testId: string }) => {
  const { t } = useTranslation();
  return (
    <div className={`${BadgeStyles.SHARED} ${getStyle(status)}`} data-testid={testId}>
      {getIcon(status)}
      <span className={BadgeStyles.SHARED_TEXT}>{t(getStatusBadgeText(status))}</span>
    </div>
  );
};

export default BillStatusBadge;
